import { createCRUDHook } from './createCRUDHook';
import { ThompsonsDieBoardPartDto } from 'utils/models';
import { TBL_THOMPSON_DIE_BOARD_PART } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<ThompsonsDieBoardPartDto>({
    entityName: 'ThompsonsDieBoardPart',
    endpoint: TBL_THOMPSON_DIE_BOARD_PART,
  });

export const ThompsonsDieBoardPartContext = Context;
export const useThompsonsDieBoardPartManager = useManager;
export const useThompsonsDieBoardPart = useConsumer;
